import React from 'react';
import { Input, Button, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

interface QueryFormProps {
  empCode: string;
  dateStart: string;
  dateEnd: string;
  loading: boolean;
  onEmpCodeChange: (v: string) => void;
  onDateRangeChange: (start: string, end: string) => void;
  onQuery: () => void;
}

const QueryForm: React.FC<QueryFormProps> = ({
  empCode,
  dateStart,
  dateEnd,
  loading,
  onEmpCodeChange,
  onDateRangeChange,
  onQuery,
}) => {
  const rangeValue: [Dayjs, Dayjs] | null =
    dateStart && dateEnd
      ? [dayjs(dateStart), dayjs(dateEnd)]
      : null;

  const handleRangeChange = (
    dates: [Dayjs | null, Dayjs | null] | null,
  ) => {
    if (dates && dates[0] && dates[1]) {
      onDateRangeChange(
        dates[0].format('YYYY-MM-DD'),
        dates[1].format('YYYY-MM-DD'),
      );
    } else {
      onDateRangeChange('', '');
    }
  };

  return (
    <div className="pw9411-query-form bg-gray-50 border border-gray-200 rounded p-4 mb-4">
      <div className="flex flex-wrap items-center gap-4">
        {/* Employee code input */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 70 }}>員工代號</span>
          <Input
            value={empCode}
            onChange={(e) => onEmpCodeChange(e.target.value.toUpperCase())}
            onPressEnter={onQuery}
            placeholder="輸入員工代號"
            style={{ width: 140 }}
            maxLength={8}
          />
        </div>

        {/* Date range picker */}
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium" style={{ width: 55 }}>日期範圍</span>
          <RangePicker
            value={rangeValue}
            onChange={handleRangeChange}
            format="YYYY-MM-DD"
            allowClear
            placeholder={['起始日', '截止日']}
            style={{ width: 260 }}
          />
        </div>

        {/* Query button */}
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={onQuery}
          loading={loading}
        >
          查詢
        </Button>
      </div>
    </div>
  );
};

export default QueryForm;
